import './App.css';

import { Provider } from 'react-redux';
import store from './redux/store';

import { Questions } from './Components/Qestions';
import MainContainer from './Components/MainContainer';

function App() {

  return (
    <Provider store={store}>
      <MainContainer />
    </Provider>
  );
}

export default App;
